import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './css/searchbar.css'
import { CircularProgress } from '@mui/material';

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    buscando?: boolean;
    placeholder?: string;
    disabled?: boolean;
}

const SearchBar: React.FC<SearchBarProps> = ({
    value,
    onChange,
    buscando = false,
    placeholder = 'Pesquisar...',
    disabled = false,
}) => {
    // Mantém um valor local para o input, garantindo que a digitação seja exibida
    // imediatamente mesmo quando o re-render do componente pai (que observa a store)
    // atrasa ou é suprimido pelo forceUpdate manual do ControleGabinete.
    const [localValue, setLocalValue] = useState(value);

    const handleChange = (novoValor: string) => {
        setLocalValue(novoValor);
        onChange(novoValor);
    };

    return (
        <div className="searchbar-container">
            <SearchIcon className="searchbar-icon" />

            <input
                type="text"
                value={localValue}
                disabled={disabled}
                placeholder={placeholder}
                onChange={(e) => handleChange(e.target.value)}
                className="searchbar-input"
            />

            {buscando ? (
                <CircularProgress size={16} thickness={4} />
            ) : (
                <button
                    className={`searchbar-clear ${localValue ? 'visible' : ''}`}
                    onClick={() => handleChange('')}
                    title="Limpar pesquisa"
                    disabled={!localValue || disabled}
                >
                    <CloseIcon fontSize="small" />
                </button>
            )}
        </div>
    );
};

export default SearchBar;
